import { getLocalized } from '../locales'

/*
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
*/
type MonthNameFormat = 'abbreviated' | 'narrow' | 'wide'

interface IMonthNameBuilderProps {
  format: MonthNameFormat
  locale?: string
}

function monthNameBuilder({ format, locale }: IMonthNameBuilderProps) {
  const requestedLocale = getLocalized(locale)

  const returnValue = []
  for (let m = 0; m < 12; m++) {
    returnValue.push(requestedLocale.month(m, { width: format }))
  }

  return returnValue
}

export default monthNameBuilder
